module.exports = __webpack_public_path__ + "static/media/natgeo.6496658b.png";